export default "__VITE_ASSET__CZkeuOFY__"